import React from 'react';
import TextAreaField from 'components/TextAreaField';
import validations from 'validations';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import './BusinessDescriptionField.styles.scss';
import './BusinessDescriptionField.styles.responsive.scss';

const BusinessDescriptionField: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="business-description-field">
      <Field
        className="lcw-description-field-textarea"
        name="businessDescription"
        component={TextAreaField}
        rows={4}
        validate={validations.required()}
        placeholder={t('businessDescriptionPlaceholder')}
        maxLength={2000}
      />
    </div>
  );
};

export default BusinessDescriptionField;
